// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyInfo_wrapper__kLQxf"};